module.exports = __webpack_public_path__ + "img/industryPage1_2.83654b26.png";